import { Box, Grid } from "@mui/material";
import GavelIcon from "@mui/icons-material/Gavel";
import BlockIcon from "@mui/icons-material/Block";
import { Button, TextInput, required, useNotify, useRecordContext, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import SecuredComponent from "server/security/SecuredComponent";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import permissions from "app/permissions";
import { DoctorantStatus } from "utils/constants";
import { validateDateNotInFuture } from "utils/validations";

const DismissFormFields = () => (
  <Grid container spacing={2} sx={{ mt: 0 }}>
    <Grid item xs={12} md={6}>
      <TextInput
        source="protocolNumber"
        label="Номер на протокола"
        validate={required("Задължително")}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <CustomDateInput
        source="protocolDate"
        label="Дата на протокола"
        validate={[required("Задължително"), validateDateNotInFuture]}
        maxDate={new Date()}
        noTime
        fullWidth
        required
      />
    </Grid>
  </Grid>
);

const ActionButtons = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record?.id || record.status !== DoctorantStatus.Active) return null;

  const dismiss = (request, successMessage) => async data => {
    await dataProvider.customRequest(
      request(record.id),
      { protocolNumber: data.protocolNumber, protocolDate: data.protocolDate },
      "POST",
    );
    notify(successMessage, { type: "success" });
    refresh();
  };

  return (
    <SecuredComponent permission={permissions.canDismissDoctorants}>
      <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
        <FormModal
          titleContent="Отчисляване с право на защита"
          saveTitle="Отчисли"
          dialogSize="md"
          onConfirm={dismiss(
            doctoralRequests.dismissDoctorantWithRightToDefend,
            "Докторантът е отчислен с право на защита",
          )}
          triggerButton={
            <Button
              label="Отчисляване с право на защита"
              variant="contained"
              color="primary"
              startIcon={<GavelIcon />}
            />
          }
        >
          Докторантът ще бъде отчислен и ще има 1 година да защити дисертацията си.
          <DismissFormFields />
        </FormModal>

        <FormModal
          titleContent="Отчисляване без право на защита"
          saveTitle="Отчисли"
          dialogSize="md"
          onConfirm={dismiss(
            doctoralRequests.dismissDoctorantWithoutRightToDefend,
            "Докторантът е отчислен без право на защита",
          )}
          triggerButton={
            <Button
              label="Отчисляване без право на защита"
              variant="contained"
              color="error"
              startIcon={<BlockIcon />}
            />
          }
        >
          Докторантът ще бъде отчислен без право на защита.
          <DismissFormFields />
        </FormModal>
      </Box>
    </SecuredComponent>
  );
};

export default ActionButtons;
